/**
 * Calculate age in full years from a birth date (ISO string or Date).
 */
export function calculateAgeFromBirthDate(birthDate: string | Date | null | undefined): number | null {
  if (!birthDate) return null;

  const birth = birthDate instanceof Date ? birthDate : new Date(birthDate);
  if (Number.isNaN(birth.getTime())) return null;

  const today = new Date();
  let age = today.getFullYear() - birth.getFullYear();
  const monthDiff = today.getMonth() - birth.getMonth();

  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birth.getDate())) {
    age--;
  }

  return age >= 0 ? age : null;
}

/** YYYY-MM-DD for `<input type="date">` from an ISO datetime string. */
export function toDateInputValue(iso: string | null | undefined): string {
  if (!iso) return '';
  return iso.slice(0, 10);
}
